import React from "react";
import { View, Modal, StyleSheet, Pressable } from "react-native";
import Text from "@components/CustomText";
import { verticalScale, scale } from "@utils/scale";
import { colors } from "@constants/theme";
export class ConfirmDelete extends React.Component {
  onPressYes = () => {
    this.props.closeModal();
    this.props.onYes();
  };
  render() {
    const { message = "" } = this.props;
    return (
      <View>
        <Modal
          statusBarTranslucent
          navigationBarTranslucent
          animationType="slide"
          transparent={true}
          visible={this.props.modalVisible}
          onRequestClose={this.props.closeModal}
        >
          <View style={styles.centeredView}>
            <View style={styles.modalView}>
              <Text
                style={[
                  styles.modalText,
                  { fontFamily: "NotoSansDevanagari-Regular", fontSize: 15 },
                ]}
              >
                {message}
              </Text>
              <View
                style={{
                  flexDirection: "row-reverse",
                  marginTop: scale(24),
                  alignItems: "flex-end",
                  width: "100%",
                }}
              >
                <Pressable
                  onPress={() => this.onPressYes()}
                  style={{
                    width: scale(60),
                    height: verticalScale(40),
                    marginLeft: scale(10),
                  }}
                >
                  <Text variant="subtitle_16" style={{ color: colors.primary }}>
                    हाँ
                  </Text>
                </Pressable>
                <Pressable
                  onPress={this.props.closeModal}
                  style={{
                    width: scale(60),
                    height: verticalScale(40),
                    marginLeft: scale(24),
                  }}
                >
                  <Text variant="subtitle_16">नहीं</Text>
                </Pressable>
              </View>
            </View>
          </View>
        </Modal>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  centeredView: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    marginTop: 22,
    backgroundColor: "rgba(0,0,0,.7)",
  },
  modalView: {
    // margin: 20,
    backgroundColor: "white",
    borderRadius: 6,
    minHeight: verticalScale(140),
    alignItems: "center",
    width: "90%",
    elevation: 3,
    paddingTop: 30,
    paddingBottom: 15,
  },
  button: {
    borderRadius: 20,
    padding: 10,
    elevation: 2,
  },
  buttonOpen: {
    backgroundColor: "#F194FF",
  },
  buttonClose: {
    backgroundColor: "#2196F3",
  },
  textStyle: {
    color: "white",
    fontWeight: "bold",
    textAlign: "center",
  },
  modalText: {
    textAlign: "center",
    color: "rgba(0, 0, 0, 0.56)",
    paddingHorizontal: 20,
  },
});
